export default __webpack_public_path__ + "static/media/dashboard-img3.d1d8dadc.svg";